import { render } from "./AppDataDisplay.vue?vue&type=template&id=4d343170&scoped=true"
import script from "./AppDataDisplay.vue?vue&type=script&lang=js"
export * from "./AppDataDisplay.vue?vue&type=script&lang=js"

import "./AppDataDisplay.vue?vue&type=style&index=0&id=4d343170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d343170"]])

export default __exports__